import React from 'react'
// Tools
import { connect } from 'react-redux'
import { useLazyLoad } from '@navent-jobs/ui-kit/hooks/lazy-loading'
import { useWindowSize } from '@navent-jobs/ui-kit/hooks/window-size'

// Components
import { MainContainer, Col, Row } from '@navent-jobs/ui-kit/components/grid'
import LogedUserSuggest from './logged-users-suggest'
import NotLogedUserSuggest from './not-logged-user-suggest'

// Styles
import { ComponentWrapper, GreyBard, Lazy } from './mixins'

interface SuggestionForUserProps {
  isUserLoggedIn: boolean
}

const SuggestionForUser = ({ isUserLoggedIn }: SuggestionForUserProps) => {
  const { isDesktop, isTabletLandscape } = useWindowSize()
  const { isVisible, containerRef } = useLazyLoad()

  return (
    <Lazy ref={containerRef}>
      {isVisible && (
        <ComponentWrapper isUserLoggedIn={isUserLoggedIn}>
          {!isUserLoggedIn && <GreyBard />}
          <MainContainer>
            <Row>
              <Col xs={12}>{isUserLoggedIn ? <LogedUserSuggest /> : <NotLogedUserSuggest />}</Col>
            </Row>
          </MainContainer>
          {!isUserLoggedIn && (isDesktop || isTabletLandscape) && <GreyBard />}
        </ComponentWrapper>
      )}
    </Lazy>
  )
}

const state = ({ applicantStore }) => ({
  isUserLoggedIn: applicantStore && applicantStore.applicant,
})

export default connect(state)(SuggestionForUser)
